import type { PersonInvolvementPartyUnbranded } from "../types/involvement.js";
import type { OfferedEndingCause } from "../types/involvementEnding.js";

/**
 * The causes offered for ending an involvement with each kind of party, in the
 * order they are offered. A cause that means the same for both is one cause,
 * so an ending reads alike whoever held the involvement; how it is worded to
 * the user ending it may still differ by kind.
 */
export const offeredEndingCausesByPartyKind: Record<
  PersonInvolvementPartyUnbranded["kind"],
  readonly OfferedEndingCause[]
> = {
  user: [
    "superseded",
    "left-role",
    "organisation-withdrew",
    "no-longer-needed",
    "added-in-error",
    "other",
  ],
  organisation: [
    "placement-moved",
    "superseded",
    "no-longer-commissioned",
    "organisation-closed",
    "no-longer-needed",
    "added-in-error",
    "other",
  ],
};
